import { useContext, useState } from "react";

import makeStyles from "@mui/styles/makeStyles";

import styles from "assets/jss/default/views/loginPageStyle.js";
import onyxLogoDark from "assets/img/ONYX_RGB_Logo.png";

import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button";
import CardFooter from "components/Card/CardFooter";
import PropTypes from "prop-types";
import { useEffectOnce } from "react-use";
import { Redirect } from "react-router-dom";
import { CognitoAuthContext } from "components/Authentication/CognitoAuthContext";
import { Alert, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

const useStyles = makeStyles(styles);

const StyledCardFooter = styled(CardFooter)`
  flex-direction: column;
`;

const StyledAlert = styled(Alert)`
  width: 100%;
  justify-content: center;
  word-break: break-word;
`;

function Login() {
  const [cardAnimation, setCardAnimation] = useState("cardHidden");

  const { user, login, error } = useContext(CognitoAuthContext);

  useEffectOnce(() => {
    let mounted = true;
    setTimeout(() => {
      if (mounted) {
        setCardAnimation("");
      }
    }, 500);
    return () => {
      mounted = false;
    };
  });

  const classes = useStyles();

  // if the user specifically asks for this page, and they are authenticated, redirect them to the main page
  if (user) {
    return <Redirect to={"/"} />;
  }

  return (
    <div className={classes.container}>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12} sm={6} md={4}>
          <Card login className={classes[cardAnimation]}>
            <CardHeader
              className={`${classes.cardHeader} ${classes.textCenter}`}
            >
              <img
                src={onyxLogoDark}
                alt="onyx logo"
                className={classes.logo}
              />
            </CardHeader>
            <CardBody className={classes.textCenter}>
              <h4>Case Management</h4>
            </CardBody>
            <StyledCardFooter>
              <div className={classes.wrapper}>
                <Button
                  onClick={() => {
                    login();
                  }}
                  size="lg"
                  block
                  fullWidth
                  color="success"
                  className={classes.button}
                >
                  Log in with ONYX SSO
                </Button>
              </div>
              {error && (
                <StyledAlert severity="error" variant="filled">
                  {String(error)}
                </StyledAlert>
              )}
            </StyledCardFooter>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}

Login.propTypes = {
  useRedirect: PropTypes.bool,
  authStartCbParams: PropTypes.object
};

export default Login;
